import { __awaiter } from "tslib";
import { filterByPlatform, filterByUser, filterByLocation, filterByVerticalAndCommunity } from './targetingFilters';
import targetingDebug from 'pathfinder/modules/MarketingNotifications/utils/targetingDebug';
export const checkTargeting = (notifications, debugStep) => __awaiter(void 0, void 0, void 0, function* () {
    let debugSubstep = 0;
    notifications = yield filterByPlatform({ notifications });
    targetingDebug('Passed platform (mobile/desktop) rule', [debugStep, ++debugSubstep], notifications);
    notifications = yield filterByUser({ notifications });
    targetingDebug('Passed user (anon/logged-in) rule', [debugStep, ++debugSubstep], notifications);
    notifications = yield filterByLocation({ notifications });
    targetingDebug('Passed geo location rule', [debugStep, ++debugSubstep], notifications);
    notifications = yield filterByVerticalAndCommunity({ notifications });
    targetingDebug('Passed vertical and community rule', [debugStep, ++debugSubstep], notifications);
    return notifications;
});
